import script from "./BulkUserUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkUserUpload.vue?vue&type=script&setup=true&lang=js"

import "./BulkUserUpload.vue?vue&type=style&index=0&id=69250905&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69250905"]])

export default __exports__